import FormattedText from "../../../FormattedText/FormattedText";
import { Action, Container, Description, Overlay, Title } from "./Styles";

interface TravelProtectionTooltipProps {
  visible?: boolean;
  tooltipData?: { title?: string; description?: string };
  onClose?: () => void;
}

export const TravelProtectionTooltip = ({
  visible,
  tooltipData,
  onClose,
}: TravelProtectionTooltipProps) => {
  if (!visible) return null;
  return (
    <>
      <Overlay onClick={onClose} aria-label="close tooltip" />
      <Container>
        <Title>
          <FormattedText value={tooltipData?.title || "Tip"} />
        </Title>
        <Description>
          <FormattedText value={tooltipData?.description || ""} />
        </Description>
        <Action onClick={onClose}>
          <FormattedText value="Got it" />
        </Action>
      </Container>
    </>
  );
};

